import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import { normalizeAppLocale, applyDocumentLanguage } from '@/i18n/languages';
import i18n, { ensureLocaleLoaded } from '@/i18n';

/** Keeps i18next in sync with the signed-in user's locale preference. */
export default function I18nSync() {
  const { user } = useAuth();
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const fromUser = (user as { locale?: string } | null)?.locale;
    const next = normalizeAppLocale(fromUser || localStorage.getItem('co_taskr_locale'));
    if (i18nInstance.language !== next) {
      void ensureLocaleLoaded(next).then(() => i18n.changeLanguage(next));
    }
    localStorage.setItem('co_taskr_locale', next);
    applyDocumentLanguage(next);
  }, [user, (user as { locale?: string } | undefined)?.locale, i18nInstance.language]);

  return null;
}
